const Browser = () => import('@/views/Browser.vue');
const Login = () => import('@/views/Login.vue');
const Register = () => import('@/views/Register.vue');
const CallBack = () => import('@/views/CallBack.vue');
const Live = () => import('@/views/Live.vue');
const SingleChat = () => import('@/views/chat/SingleChat.vue');
const ThingsChat = () => import('@/views/chat/ThingsChat.vue');
const TeamworkChat = () => import('@/views/chat/TeamworkChat.vue');
const TodoChat = () => import('@/views/chat/TodoChat.vue');
const MemoChat = () => import('@/views/chat/MemoChat.vue');

import conf from'@/config/config';
const LoginUrl = conf.loginurl;

import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: '/browser'
  },
  {
    path: '/browser',
    name: 'Browser',
    component: Browser,
     meta: {
       title: "Jujue - Mote Browser"
    },
    // beforeEnter (to, from, next) {
    //   store.dispatch('fetchUser');
    //   if (store.state.Uid) {
    //     next();
    //   } else {
    //     store.dispatch('setReturnUrl', to.fullPath);
    //     window.location.href = LoginUrl;
    //   }
    // }
  },
  {
    path: '/Live',
    name: 'Live',
    component: Live,
     meta: {
       title: "Jujue Live"
    },
    children: [
      {
        path: 'singlechat',
        name: 'SingleChat',
        component: SingleChat,
        meta: {
          title: "Singe Live Chat"
       }
      },
      {
        path: 'thingschat',
        name: 'ThingsChat',
        component: ThingsChat,
        meta: {
          title: "Things Chat"
       }
      },
      {
        path: 'teamwork',
        name: 'TeamworkChat',
        component: TeamworkChat,
        meta: {
          title: "Team Work"
       }
      },
      {
        path: 'todo',
        name: 'TodoChat',
        component: TodoChat,
        meta: {
          title: "To Do"
       }
      },
      {
        path: 'memo',
        name: 'MemoChat',
        component: MemoChat,
        meta: {
          title: "Memo"
       }
      }
    ]
  },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: Login,
  //   meta: {
  //     title: "Sign In"
  //   },
  //   beforeEnter (to, from, next) {
  //     store.dispatch('fetchUser');
  //     if (!store.state.UToken) {
  //       next();
  //     } else {
  //       next('/browser');
  //     }
  //   }
  // },
  // {
  //   path: '/register',
  //   name: 'Register',
  //   component: Register,
  //   meta: {
  //     title: "Sign Up"
  //   },
  //   beforeEnter (to, from, next) {
  //     store.dispatch('fetchUser');
  //     if (!store.state.UToken) {
  //       next();
  //     } else {
  //       next('/browser');
  //     }
  //   }
  // },
  {
    path: '/callback',
    name: 'CallBack',
    component: CallBack,
    meta: {
      title: "callback login"
    },
    beforeEnter (to, from, next) {
      store.dispatch('fetchUser');
      if (!store.state.UToken) {
        next();
      } else {
        next('/browser');
      }
    }
  }
];

export default routes;
